.bundleProgressContainer {
  border: 1px solid var(--colors-grays-ultralight);
  background: var(--colors-grays-ultralight);
  width: 100%;
  padding: 24px;
}

.bundleProgressCardsContainer {
  display: flex;
  justify-content: center;
}

.bundleProgressCards {
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding-top: 24px;
  padding-bottom: 24px;
  overflow-x: scroll;
  scrollbar-width: none;
}

.bundleProgressCards::-webkit-scrollbar {
  display: none;
}

.title {
  font-weight: bold;
  font-size: 20px;
  text-align: left;
}

.titleQualified {
  color: var(--colors-info-main);
}

@media all and (--reefer-media-tablet-min) {
  .bundleProgressContainer {
    border-radius: 20px;
    padding: 40px;
    margin-bottom: 16px;
  }

  .title {
    text-align: center;
  }

  .bundleProgressCards {
    padding-bottom: 40px;
  }
}
